import { useParams, Link } from "react-router-dom";
import { products } from '../data/products';

export default function ProductDetail() {
  const { id } = useParams();
  const product = products.find((item) => String(item.id) === String(id));

  if (!product) {
    return <main className="pd-page"><div className="pd-wrap"><h1>Mahsulot topilmadi</h1><Link to="/Products">← Mahsulotlarga qaytish</Link></div></main>;
  }

  const hasPrice = product.price && product.price !== "0 UZS";
  const videoId = product.videoId && product.videoId !== "dQw4w9WgXcQ" ? product.videoId : "";

  return (
    <main className="pd-page">
      <div className="pd-wrap">
        <nav className="pd-crumb"><Link to="/Products">← Mahsulotlarga qaytish</Link><span>/</span><span>{product.name}</span></nav>
        <header className="pd-title-row">
          <div><span className="pd-kicker">NAVOI ETM · ONLAYN KASSA TEXNIKALARI</span><h1>{product.name}</h1><p>Ishonchli savdo texnologiyalari va kundalik ish jarayoningiz uchun qulay yechim.</p></div>
          <span className="pd-model">MODEL<strong>{String(product.id).padStart(2, "0")}</strong></span>
        </header>
        <section className="pd-layout">
          <div className="pd-left">
            <div className="pd-image-box"><span className="pd-image-label">MAHSULOT KO‘RINISHI</span><img src={product.img} alt={product.name} /></div>
            <div className="pd-caption"><i /> Rasm mahsulot ko‘rinishini aks ettiradi</div>
          </div>
          <div className="pd-right">
            <section className="pd-card">
              <span className="pd-kicker">MAHSULOT HAQIDA</span><p className="pd-desc">{product.desc}</p>
              <div className="pd-facts">
                <div><span className="pd-icon">₽</span><span><small>Narxi</small><strong>{hasPrice ? product.price : "Narxni aniqlashtiring"}</strong></span></div>
                <div><span className="pd-icon">✓</span><span><small>Kafolat</small><strong>{product.warranty || "Ma’lumot uchun bog‘laning"}</strong></span></div>
              </div>
              <div className="pd-actions"><Link className="pd-btn pd-primary" to={`/Contact?product=${encodeURIComponent(product.name)}`}>Mahsulot haqida so‘rash ↗</Link><Link className="pd-btn pd-secondary" to="/Products">Boshqa mahsulotlar</Link></div>
            </section>
            {product.features?.length > 0 && <section className="pd-card pd-specs"><div className="pd-section-head"><div><span className="pd-kicker">TEXNIK MA’LUMOT</span><h2>Asosiy xususiyatlar</h2></div><b>{String(product.features.length).padStart(2, "0")}</b></div><ul>{product.features.map((feature, i) => <li key={`${product.id}-${i}`}><span>✓</span>{feature}</li>)}</ul></section>}
          </div>
        </section>
        {videoId && <section className="pd-card pd-video"><div className="pd-section-head"><div><span className="pd-kicker">VIDEO SHARH</span><h2>Mahsulotni yaqindan tanishing</h2></div><b>▶</b></div><div className="pd-video-frame"><iframe src={`https://www.youtube-nocookie.com/embed/${videoId}`} title={`${product.name} video sharhi`} loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen /></div></section>}
      </div>
    </main>
  );
}
